import { useEffect, useState, useSyncExternalStore } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { CloudOff, Loader2, RefreshCw } from "lucide-react"
import { kuyrukDurumu, kuyruguDinle, kuyruguGonder } from "@/lib/cevrimdisi/kuyruk"
import { cn } from "@/lib/utils"

/** Tarayıcının bağlantı durumu (değişince yeniden çizilir). */
export function useCevrimici() {
  const [cevrimici, setCevrimici] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine))
  useEffect(() => {
    const ac = () => setCevrimici(true)
    const kapa = () => setCevrimici(false)
    window.addEventListener("online", ac)
    window.addEventListener("offline", kapa)
    return () => {
      window.removeEventListener("online", ac)
      window.removeEventListener("offline", kapa)
    }
  }, [])
  return cevrimici
}

export function useKuyrukDurumu() {
  return useSyncExternalStore(kuyruguDinle, kuyrukDurumu)
}

/**
 * ÇEVRİMDIŞI ROZETİ — her ekranın sol alt köşesinde, yalnız gerektiğinde:
 * bağlantı yoksa ya da cihazda gönderilmeyi bekleyen kayıt varsa. Sahadaki
 * kullanıcı doldurduğunun kaybolmadığını, ne zaman gideceğini buradan görür.
 */
export function CevrimdisiRozeti() {
  const qc = useQueryClient()
  const cevrimici = useCevrimici()
  const { bekleyen, gonderiliyor, reddedilen } = useKuyrukDurumu()
  if (cevrimici && bekleyen === 0 && reddedilen === 0) return null

  return (
    <div
      className={cn(
        "fixed bottom-3 left-3 z-[60] flex max-w-[calc(100vw-1.5rem)] items-center gap-2 rounded-full border px-3 py-1.5 text-xs shadow-lg",
        cevrimici ? "border-sky-200 bg-sky-50 text-sky-900" : "border-amber-300 bg-amber-50 text-amber-900",
      )}
      role="status"
    >
      {gonderiliyor ? <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" /> : !cevrimici ? <CloudOff className="h-3.5 w-3.5 shrink-0" /> : <RefreshCw className="h-3.5 w-3.5 shrink-0" />}
      <span className="min-w-0 truncate">
        {!cevrimici ? "Çevrimdışı" : gonderiliyor ? "Gönderiliyor…" : "Bağlantı var"}
        {bekleyen > 0 && ` · ${bekleyen} kayıt cihazda bekliyor`}
        {reddedilen > 0 && ` · ${reddedilen} kayıt sunucu tarafından reddedildi`}
      </span>
      {cevrimici && bekleyen > 0 && !gonderiliyor && (
        <button type="button" className="shrink-0 font-semibold underline-offset-2 hover:underline" onClick={() => void kuyruguGonder(qc)}>
          Şimdi gönder
        </button>
      )}
    </div>
  )
}
